import { MarkerProps } from 'components/elements/maps/Marker'

/**
 * 型定義：座標
 */
export type CoordsProps = {
  lat: number
  lng: number
}

/**
 * 型定義：座標+住所
 */
export type LocationProps = CoordsProps & {
  address?: string
}

/**
 * 型定義：場所名+座標+住所
 */
export type LocationConfirmProps = CoordsProps & {
  locationName: string
  address: string
}

/**
 * 型定義：場所名+座標+住所+選択状況
 */
export type LocationConfirmStateProps = LocationConfirmProps & {
  isSelected: boolean
}

/**
 * 型定義：座標+共有のON/OFF
 */
export type CoordsWithVisibleProps = CoordsProps & {
  locationCooperation: boolean
}

/**
 * 型定義：マップマーカー
 */
export type PointProps = CoordsProps & {
  address?: string
  key: string
  component: React.FC<any>
}

/**
 * 型定義：場所検索結果
 */
export type SearchResultPlaceProps = LocationConfirmProps & {
  renderingMarker: MarkerProps
  controlMarker: google.maps.Marker
  infoWindow: google.maps.InfoWindow
}

/**
 * マップの自動調整時に確保するマージンサイズ
 */
export const MARKER_BOUNDS_MARGIN = 80

/**
 * 場所選択マップのデフォルトズーム
 */
export const SELECT_PLACE_MAP_DEFAULT_ZOOM = 16

/**
 * 検索結果のマーカークリック時のズーム
 */
export const MAP_ZOOM_ON_CLICK_MARKER = 14

/**
 * 位置共有マップのデフォルトズーム
 */
export const TRACKING_MAP_DEFAULT_ZOOM = 14

/**
 * マップの言語
 */
export const MAP_LANGUAGE = 'ja'

/**
 * マップのリージョン
 */
export const MAP_REGION = 'ja'

/**
 * マップのオプション
 */
export const MAP_OPTIONS = {
  gestureHandling: 'greedy',
  fullscreenControl: false,
  styles: [
    {
      featureType: 'all',
      elementType: 'all',
      stylers: [{ saturation: '-20' }, { gamma: '1' }, { lightness: '10' }],
    },
    {
      featureType: 'transit.line',
      elementType: 'all',
      stylers: [{ saturation: '-100' }],
    },
  ],
}

/**
 * 確認画面等の小さなマップのオプション
 */
export const CONFIRM_MAP_OPTIONS = {
  draggable: false,
  zoomControl: false,
  fullscreenControl: false,
  styles: [
    {
      //全体
      featureType: 'all',
      elementType: 'all',
      stylers: [{ saturation: '-20' }, { gamma: '1' }, { lightness: '10' }],
    },
    {
      //ラベルアイコン
      featureType: 'all',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'transit.line',
      elementType: 'all',
      stylers: [{ saturation: '-100' }],
    },
  ],
}

/**
 * パートナーの移動間隔（ミリ秒）
 */
export const MAKER_MOVE_INTERVAL = 3000

/**
 * 型定義：位置共有座標
 */
export type TrackingProps = CoordsProps & {
  visible: boolean
}

/**
 * google-map-reactのfitBoundsで2つのマーカーが同座標な場合、
 * 正常に座標計算できない問題の対策でずらす座標の量
 */
export const BOUNDS_AMOUNT_TO_SHIFT = 0.00000000001
